export default "__VITE_ASSET__BpjZzpd0__"